import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import ProviderInvitationInformationCard from "./ProviderInvitationInformationCard";
import { LangContext } from "../LangContext.jsx";
class InvitationPerson extends Component {
    static contextType = LangContext; 
    constructor(props) {
        super();
        this.state = {
            invitation:{
                status:''
            },
            documents:[]
        };
        this.resendInvitation = this.resendInvitation.bind(this)
    }

    componentDidMount() {
        this.getInvitation() 
    }

    async getInvitation(){
        const res = await axios.get('/api/invitations/' + this.props.invitation_id);
        this.setState({invitation: res.data})
        this.setState({
            documents: res.data.dossier.documents.concat(res.data.additional_documents,
                (res.data.scheduled_documents || []).filter(item => item.document).map(item => ({ ...item.document, scheduled: true })))
        });
    }

    async resendInvitation() {
        const { lang } = this.context; 
        window.blockUI();
        await axios.put(
            '/api/invitations/' + this.props.invitation_id + '/forwarding',
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: lang.get('messages.invitacion_reenviada'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        }).catch((error) => {
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        }).then(() => {
            window.unblockUI();
        });;
    }

    confirmDelete = ()=>{
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_eliminar_esta_invitacion'),
            input: 'textarea',
            inputLabel: 'Motivo de eliminación (opcional)',
            inputPlaceholder: 'Captura el motivo de la eliminación',
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteInvitation(result.value || '');
            }
        });
    }

    deleteInvitation = (deletionReason = '') => {
        window.blockUI();
        axios.delete(
            '/api/persons/invitation/' + this.props.invitation_id,
            {
                data: {
                    deletion_reason: deletionReason,
                },
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            window.location.href = '/';
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: 'Algo salió mal, intenta de nuevo',
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    formatDate(date) {
        if (!date) return '-';
        return new Date(date).toLocaleString('es-MX');
    }

    getDeletedByEmail() {
        return this.state.invitation.deleted_by?.email || '-';
    }

    renderDeletedInvitationDetails() {
        const invitation = this.state.invitation;

        if (!invitation.deleted_at) {
            return null;
        }

        return <div className="text-center align-self-end p-sm-16 p-10 bg-white rounded border border-gray mb-10">
            <div className="mt-2">
                <div className="row text-left">
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Fecha y hora</p>
                        <p className="text-left font-weight-bold">{this.formatDate(invitation.deleted_at)}</p>
                    </div>
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Usuario</p>
                        <p className="text-left font-weight-bold">{this.getDeletedByEmail()}</p>
                    </div>
                </div>
                <div className="row text-left">
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">{invitation.identity || 'RFC'}</p>
                        <p className="text-left font-weight-bold">{invitation.rfc?.toUpperCase()}</p>
                    </div>
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Razón social</p>
                        <p className="text-left font-weight-bold">{invitation.name}</p>
                    </div>
                </div>
                <div className="row text-left">
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Expediente</p>
                        <p className="text-left font-weight-bold">{invitation.dossier?.id || invitation.dossier_id}{invitation.dossier?.title ? ` - ${invitation.dossier.title}` : ''}</p>
                    </div>
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Correo del destinatario</p>
                        <p className="text-left font-weight-bold">{invitation.email}</p>
                    </div>
                </div>
                <div className="row text-left">
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Tipo de invitación</p>
                        <p className="text-left font-weight-bold">{invitation.invitation_type || 'Nueva invitación'}</p>
                    </div>
                    <div className="col-sm-6">
                        <p className="text-muted text-left font-weight-bold">Motivo de eliminación</p>
                        <p className="text-left font-weight-bold">{invitation.deletion_reason || '-'}</p>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        const { lang } = this.context; 
        const canResendInvitation = this.props.permissions?.providers?.includes('all') || this.props.permissions?.providers?.includes('resend_invitation');
        const canDeleteInvitations = this.props.permissions?.providers?.includes('all') || this.props.permissions?.providers?.includes('delete_invitations');
        const isDeletedInvitation = !!this.state.invitation?.deleted_at;
        const canShowInvitationActions = !isDeletedInvitation && (this.props.usermode == 'provider' || canResendInvitation || canDeleteInvitations);

        return (<div className="container">
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap w-100">
                    <ProviderInvitationInformationCard invitation_id={this.props.invitation_id} />
                    <div className="text-center align-items-center flex-wrap col-2">
                        <span className="text-dark font-weight-bold">Estatus</span><br/>
                        {isDeletedInvitation ?
                            <span className="badge badge-secondary">Eliminada</span>
                            : this.state.invitation?.status == 'Declinado' ?
                            <span className={'badge badge-'+this.state.invitation?.status.toString().toLowerCase()}>Declinado</span>
                            :
                            <span className={'badge badge-'+this.state.invitation?.status.toString().toLowerCase()}>{ this.state.invitation?.status }</span>
                        }
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {canShowInvitationActions &&
                            <div className="dropdown dropdown-inline">
                                <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {lang.get('messages.acciones')}
                                    &nbsp;&nbsp;
                                    <i className="flaticon2-down icon-sm"></i>
                                </a>
                                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg" style={{ background: '#F0E9FF' }}>
                                <ul className="navi navi-hover"> 
                                    {this.props.usermode == 'provider' && 
                                        <li className="navi-item">
                                            <a href={'/persons/invitations/'+this.props.invitation_id+'/accept'}  className="navi-link py-4"  >
                                                <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-interface-5 text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.aceptar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </a>
                                            <a href={'/persons/invitations/'+this.props.invitation_id+'/refuse'}  className="navi-link py-4"  >
                                                <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon2-cross text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.rechazar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </a>
                                        </li>
                                    } 
                                    {this.props.usermode == 'client' && 
                                    <>
                                        {canResendInvitation && (
                                        <li className="navi-item">
                                            <span role="button" onClick={() => this.resendInvitation()}  className="navi-link py-4 cursor">
                                                <span className="navi-icon mr-5 text-center">
                                                    <span className="flaticon2-mail text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.reenviar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </span>
                                        </li>
                                        )}
                                        {canDeleteInvitations && (
                                        <li className="navi-item">
                                            <span role="button" onClick={()=>{ this.confirmDelete() }}  className="navi-link py-4 cursor">
                                                <span className="navi-icon mr-5 text-center">
                                                    <span className="flaticon-delete fw-normal text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.borrar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </span>
                                        </li>
                                        )}
                                        </>
                                        } 
                                    </ul>
                                </div>
                            </div>
                        } 
                    </div>
                </div>
            </div>
            {this.renderDeletedInvitationDetails()}
            <div className="p-15 card card-custom d-block" id="kt_subheader">
                <div className="mb-10">
                    {lang.get('messages.listado_de_documentos_del_expediente')} <span className="text-success"></span>
                </div>
                { this.state.documents?.map((d, i) => {
                    return <div key={i} className="mb-2 font-weight-bolder">
                        <i className="flaticon2-check-mark text-primary mr-4" style={{"fontSize": "0.80rem"}}></i>
                        { d.title }
                        {d.scheduled && <span className="text-muted ml-2">(programado)</span>}
                    </div>
                })}
            </div> 
        </div>);
    }
}

export default InvitationPerson;

if (document.getElementById('InvitationPerson')) {
    ReactDOM.render(<InvitationPerson />, document.getElementById('InvitationPerson'));
}
